/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import usePrevious from 'react-utils/hooks/usePrevious';
import UsageTracker from '../utils/UsageTracker';
import { SCREENS } from '../constants/Tracking';
import { getRecommendations, getTopicPreferences

// @ts-expect-error Could not find a declaration file for module
} from '../actions/RecommendationsActions';
// @ts-expect-error Could not find a declaration file for module
import { useFetchTracksLessonsData } from '../hooks/catalogPageHooks';
import MostPopularCertificates from '../components/MostPopularCertificates/MostPopularCertificates';
import FeaturedSoftwareCoursesSection from '../components/FeaturedSoftwareCoursesSection/FeaturedSoftwareCoursesSection';
import HomePageLayout from '../components/Layouts/HomePageLayout';
import { useIsHomepageMLRecommendationsExperimentVariation, useRecommendationsTopicPreference } from '../features/recommendations';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Homepage = () => {
  const dispatch = useDispatch();
  const {
    recommendationsTopicPreference
  } = useRecommendationsTopicPreference();
  const hasError = useSelector(state => state.tracks.get('hasError'));
  const recentError = useSelector(state => state.tracks.get('recentError'));
  const isHomepageMLRecommendationsExperimentVariation = useIsHomepageMLRecommendationsExperimentVariation();
  useFetchTracksLessonsData();
  useEffect(() => {
    UsageTracker.track('pageView', {
      screen: SCREENS.HOME
    });
    dispatch(getTopicPreferences());
    if (isHomepageMLRecommendationsExperimentVariation === false) {
      dispatch(getRecommendations());
    }
  }, [dispatch, isHomepageMLRecommendationsExperimentVariation]);
  const previousSavedTopicPreference = usePrevious(recommendationsTopicPreference);
  useEffect(() => {
    if (previousSavedTopicPreference && previousSavedTopicPreference !== recommendationsTopicPreference) {
      if (isHomepageMLRecommendationsExperimentVariation === false) {
        dispatch(getRecommendations());
      }
    }
  }, [dispatch, isHomepageMLRecommendationsExperimentVariation, previousSavedTopicPreference, recommendationsTopicPreference]);
  return /*#__PURE__*/_jsx(HomePageLayout, {
    error: hasError ? recentError : null,
    footerComponent: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(MostPopularCertificates, {}), /*#__PURE__*/_jsx(FeaturedSoftwareCoursesSection, {})]
    })
  });
};
export default Homepage;